import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SystemVehicleOperationUploadApiResponse } from './models/system-vehicle-operation-upload-api-response';
import { GenericList } from './models/generic-list';
import { SystemVehicleOperationRead } from './models/system-vehicle-operation-read';

import { ServicerProvider } from './servicer';

const BASE_URL = '/v2/system/vehicleOperation';

/**
 * [システム] 車両稼働 のプロバイダー.
 */
@Injectable()
export class SystemVehicleOperationServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * レコードを取得します.
   * 
   * @returns Observable<GenericList<SystemVehicleOperationRead>>
   */
  findAll(): Observable<GenericList<SystemVehicleOperationRead>> {
    return this.list().map((res) => {
      res.items.forEach((item) => {
        item.screenStartWorkDt = new Date(item.startWorkDt);
        item.screenEndWorkDt = new Date(item.endWorkDt);
      });

      return res;
    });
  }

  /**
   * レコードを取得します.
   * 
   * @returns Observable<GenericList<SystemVehicleOperationRead>>
   */
  list(): Observable<GenericList<SystemVehicleOperationRead>> {
    return this.servicer.list(BASE_URL);
  }

  /**
   * データアップロード.
   *
   * @param file ファイル
   * @returns Observable<ApiResponse>
   */
  upload(file: Blob): Observable<SystemVehicleOperationUploadApiResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.servicer.postFormDataNonResultFail<SystemVehicleOperationUploadApiResponse>(BASE_URL, formData);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-vehicle-operation-service.ts